/**
 * @file creative search におけるASPECT_RATIOの組み合わせ. これ以外はない + グルーピングが必要なので固定値で管理している。
 */

export const YOKONAGAS = ['16:9', '6:5'];
export const TATENAGAS = ['4:5', '3:4', '2:3', '9:16'];
export const SEIHOS = ['1:1'];
export const ASPECT_RATIOS = [...YOKONAGAS, ...TATENAGAS, ...SEIHOS];
